import { render } from "./ContactsMergeButton.vue?vue&type=template&id=368a5ce6&scoped=true&ts=true"
import script from "./ContactsMergeButton.vue?vue&type=script&lang=ts"
export * from "./ContactsMergeButton.vue?vue&type=script&lang=ts"

import "./ContactsMergeButton.vue?vue&type=style&index=0&id=368a5ce6&lang=scss&scoped=true"

import exportComponent from "/private/var/folders/bn/cmp7482d0pnd0bj6pmy1gdj40000gn/T/deploy/contacts-ui/1a3855c3e2aea7b6a4fd4d74131a5b05d89c321c/node_modules/.pnpm/vue-loader@17.0.1_@vue+compiler-sfc@3.2.37_vue@3.4.18_webpack@5.91.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-368a5ce6"]])

export default __exports__